var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._t("default",null,{"job":_vm.job,"onlineJobTypes":_vm.onlineJobTypes,"childProtectionPreviewUrls":_vm.childProtectionPreviewUrls})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }